export default __webpack_public_path__ + "static/media/arrow-down.8a04dee8.svg";